import { axiosAPI, responseHandler } from 'utils';

const apiPoint = '/api/config/';

export default {
  get() {
    return responseHandler(axiosAPI.get(apiPoint));
  },
  async getMobileLoginParentVideos() {
    const result = await responseHandler(axiosAPI.get(apiPoint, {
      params: { _: Date.now() },
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
    }));

    return {
      ...result,
      data: result?.data?.parentVideos?.mobileLoginSettings || {},
    };
  },
  update(data) {
    return responseHandler(axiosAPI.put(apiPoint, data));
  },
};
